<template>
    <div class="page">
      <div class="agenda">
        <div class="agenda-top">
          <div class="agendaTitle">{{ props.data.titleCn }}</div>
          <div class="agendaEn">{{ props.data.titleEn }}</div>
        </div>
        <div class="agenda-bottom">
          <div class="bottom-tab">
            <div :class="[currentActiveTab == index?'tab-active':'tab-default']" v-for="(item, index) in props.data.list" :key="index" @click="activeTab(index)">
              <img class="tab-img" :src="currentActiveTab === index ? 'https://p1.ssl.qhimg.com/t110b9a930196a6a4737d1c9519.png' : 'https://p5.ssl.qhimg.com/t110b9a9301ccb8ecf00ccb1295.png'" alt="" />
              <div class="tab-title">{{ item.date }}</div>
            </div>
          </div>
          <div class="bottom-content">
            <div class="content-type">
              <div :class="[currrentType==index?'type-active':'type-default']" v-for="(item, index) in typeList" :key="index" @click="activeType(index)">{{ item.title }}</div>
            </div>
            <div class="content-nr">
              <div class="nr-item" v-for="(item,index) in contentList" :key="index">
                <div class="nr-title">{{item.time}}</div>
                <div class="nr-child">
                  <div class="child-box" v-for="(child,indexa) in item.detail" :key="indexa">
                    <div class="child-left">{{child.title}}</div>
                    <div class="child-right">
                      <div class="right-dz">
                        <img src="https://p3.ssl.qhimg.com/t110b9a9301b6e2287d90efa823.png" alt="" />
                        {{child.place}}</div>
                      <div class="right-tz" v-if="child.path" @click="jumpLink(child.path)">
                        <img src="https://p0.ssl.qhimg.com/t110b9a9301d4d98c0cb78ad3ee.png" alt="" />
                        查看详情</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import { ref,computed } from 'vue'

let currentActiveTab = ref(0);
let currrentType = ref(0);
const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})
const typeList = computed(() => {
  if(props.data.list){
    return props.data.list[currentActiveTab.value].info||[];
  }
});
const contentList = computed(() => {
  if(props.data.list){
    return props.data.list[currentActiveTab.value].info[currrentType.value].children || [];
  }
})
const activeTab = (index) => {
  currentActiveTab.value = index;
  currrentType.value = 0;
}
const activeType = (index) => {
  currrentType.value = index;
}
const jumpLink = (url) => {
  if(url) {
    window.open(url, '_blank');
  }
}

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .agenda {
    width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 116px;
    .agenda-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .agendaTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .agendaEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .agenda-bottom{
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 60px;
      .bottom-tab{
        width: 100%;
        display: flex;
        align-items: center;
        border-radius: 8px;
        overflow: hidden;
        border-bottom: 1px solid rgba(201, 208, 226, 1);
        .tab-default {
          width: 33.33%;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 1);
          cursor: pointer;
          .tab-img {
            width: 32px;
            height: 32px;
          }
          .tab-title {
            color: rgba(44, 44, 44, 1);
            font-family: Microsoft YaHei;
            font-size: 20px;
            font-weight: 400;
            letter-spacing: 0px;
            margin-left: 8px;
          }
          &:hover{ 
            .tab-title {
              color: rgba(48, 74, 234, 1);
            }
          }
        }
        .tab-active{
          width: 33.33%;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(48, 74, 234, 1);
          border-radius: 8px;
          cursor: pointer;
          .tab-img {
            width: 32px;
            height: 32px;
          }
          .tab-title {
            color: rgba(255, 255, 255, 1);
            font-family: Microsoft YaHei;
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 0px;
            margin-left: 8px;
          }
        }
      }
      .bottom-content{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        border-radius: 12px;
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.15);
        background: rgba(255, 255, 255, 1);
        padding: 0 80px;
        .content-type{
          display: flex;
          align-items: center;
          width: 100%;
          height: 70px;
          border-bottom: 1px solid var(--文字黑色, rgba(44, 44, 44, 1));
          margin-top: 20px;
          .type-active{
            padding: 0 24px;
            color: rgba(44, 44, 44, 1);
            font-family: Microsoft YaHei;
            font-size: 16px;
            font-weight: 600;
            line-height: 16px;
            letter-spacing: 0px;
            cursor: pointer;
            border-left: 1px solid rgba(177, 176, 176, 1);
          } 
          .type-default{
            padding: 0 24px;
            color: rgba(44, 44, 44, 1);
            font-family: Microsoft YaHei;
            font-size: 16px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: 0px;
            cursor: pointer;
            border-left: 1px solid rgba(177, 176, 176, 1);
            &:hover{
              font-weight: 600;
            }
          }
        }
        .content-nr{
          width: 100%;
          display: flex;
          flex-direction: column;
          padding: 48px 0 16px;
          .nr-item{
            width: 100%;
            display: flex;
            flex-direction: column;
            .nr-title{
              width: 100%;
              height: 36px;
              background: linear-gradient(270.00deg, rgba(48, 74, 234, 0.05),rgba(48, 74, 234, 0.1) 100%);
              color: rgba(48, 74, 234, 1);
              font-family: Microsoft YaHei;
              font-size: 16px;
              font-weight: 600;
              line-height: 22px;
              letter-spacing: 0px;
              display: flex;
              align-items: center;
              padding: 0 24px;
            }
            .nr-child{
              width: 100%;
              display: flex;
              flex-direction: column;
              margin-bottom: 48px;
              .child-box{
                width: 100%;
                height: 70px;
                display: flex;
                align-items: center;
                padding: 0 12px;
                border-bottom: 0.5px solid rgba(177, 176, 176, 1);
                .child-left{
                  color: rgba(44, 44, 44, 1);
                  font-family: Microsoft YaHei;
                  font-size: 16px;
                  font-weight: 400;
                  flex: 1;
                }
                .child-right{
                  width: 32%;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .right-dz{
                    display: flex;
                    align-items: center;
                    color: rgba(44, 44, 44, 1);
                    font-family: Microsoft YaHei;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                    letter-spacing: 0px;
                    margin-right: 24px;
                    img{
                      width: 20px;
                      height: 20px;
                      margin-right: 8px;
                    }
                  }
                  .right-tz{
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    color: rgba(44, 44, 44, 1);
                    font-family: Microsoft YaHei;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                    letter-spacing: 0px;
                    margin-right: 24px;
                    img{
                      width: 20px;
                      height: 20px;
                      margin-right: 8px;
                    }
                    &:hover{
                      color: rgba(48, 74, 234, 1);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
